// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26gQp","delete":"styles_delete__NW9Fn","update":"styles_update__3BYJG","add":"styles_add__3AYQP"};